import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero start */}
      <div 
        className="inner-page-hero" 
        style={{ backgroundImage: 'url(assets/images/background/bg3.png)' }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>About Us</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">About Us</Link></li>
          </ul>
        </div>
      </div>
      {/* inner-page hero end */}

      {/* about three start */}
      <div className="about-four">
        <div className="about-four-shape-one-1">
          <img src="assets/images/shape/about-shape-1.png" alt="shape" />
        </div>
        <div className="about-four-shape-one-2">
          <img src="assets/images/shape/service-shape-2.png" alt="shape" />
        </div>
        <div className="container">
          <div className="row gutter-y-60">
            <div className="col-xl-7 col-lg-10">
              <div className="about-four-info">
                <div className="heading-box">
                  <span className="heading-subtitle wow fadeInUp animated animated">⭐ ABOUT US</span>
                  <h2 className="heading-title wow fadeInUp animated animated">Empowering Your Goals with Expert Financial Solutions</h2>
                </div>
                <div className="section-details">
                  <p>
                    <b>Wall Street Finz</b>  is one of the leading consumer lending platforms in India, committed to empowering young working professionals. Our objective is to create a strong financial ecosystem where mid-income individuals can fulfill all their goals with confidence. Here at Wallstreet Loan, we believe in making credit available, seamless, and truly affordable at scale.</p>
                 <br/> <p>We are also adapting, just like the growing financial needs of our customers. To support their aspirations and enhance their lifestyle, we offer a comprehensive suite of lending solutions-from short-term Instant Cash Loans. We envision ourselves to provide smarter, faster, and more reliable credit choices for today's dynamic generation.</p>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-8 ms-auto">
              <div className="row gutter-y-30">
                <div className="col-sm-7 col-6">
                  <div className="about-four-image">
                    <img src="assets/images/about/about1.jpeg" alt="about-image" />
                  </div>
                </div>
                <div className="col-sm-5 col-6 ">
                  <div className="about-four-right">
                    <div className="about-four-images">
                      <img src="assets/images/about/about2.jpeg" alt="about-image" />
                    </div>
                    <div className="about-experiences-box">
                      <div className="about-four-shape"></div>
                      <img src="/assets/images/logo.png"  alt="logo" />
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="about-four-box">
                <div className="about-four-icon">
                  <i className="flaticon-mission"></i>
                </div>
                <div className="about-four-details">
                  <h4>Our Vision</h4>
                  <p>Improve lives by providing unparalleled access to innovative and affordable financial products that allow people to do more, live better, and move forward with confidence.</p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="about-four-box">
                <div className="about-four-icon">
                  <i className="flaticon-targeting"></i>
                </div>
                <div className="about-four-details">
                  <h4>Our Mission</h4>
                  <p>Our mission is to become the market leader in consumer lending by offering fast, transparent, and reliable credit solutions for the evolving financial needs of today's young and ambitious professionals.</p></div>
              </div>
            </div>
           {/*  <div className="col-xl-4 col-lg-6">
              <div className="about-four-box">
                <div className="about-four-icon">
                  <i className="flaticon-active"></i>
                </div>
                <div className="about-four-details">
                  <h4>Core Values</h4>
                  <p>We believe in trust, transparency, and integrity as the pillars of every financial solution we provide. Guided by a customer-first approach, we listen, understand, and deliver lending options that empower growth. Our commitment to excellence and innovation ensures faster, smarter, and reliable services, building lasting relationships based on respect and confidence.</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* about three end */}

      
      {/* Why Choose One */}
      <section className="why-choose-section-one ">
        <div className="why-choose-shape-one-1"><img alt="shape" src="/assets/images/shape/why-choose-shape-1.png" /></div>
        <div className="why-choose-shape-one-2"><img alt="shape" src="/assets/images/shape/why-choose-shape-2.png" /></div>
        <div className="container">
          <div className="row gutter-y-30">
            <div className="col-xl-9 why-choose-left-one">
              <div className="heading-box heading-white">
                <span className="heading-subtitle wow fadeInUp animated animated">⭐ WHY CHOOSE</span>
                <h2 className="heading-title wow fadeInUp animated animated">Wall Street Finz — Your trusted partner for Pay Day Loan solutions and expert financial guidance.</h2>
              </div>
              <div className="why-choose-one-image">
                <img alt="why-choose-image" src="/assets/images/trustedpartner.png" />
              </div>
              
            </div>
            <div className="col-xl-3 col-lg-12">
              <ul className="counter-box-one why-choose-one-box why-choose-box-one-title">
                <li><div className="why-choose-box-one-title">
                      <i className="flaticon-solution"></i>
                      <h4>Seamless Experience</h4>
                    </div><span>01</span><p>Enjoy a smooth, hassle-free journey from application to disbursal.</p></li>
                <li><div className="why-choose-box-one-title">
                      <i className="flaticon-badge"></i>
                      <h4>Quick Approvals</h4>
                    </div><span>02</span><p>Experience faster processing and approvals to help you access funds.</p></li>
               
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* why-choos one end */}

      
      <br/>
      <br/>
      <br/>
    </>
  );
};

export default AboutUs;